import { FC } from "react";

import BaseButton from "@/components/BaseButton";

import { StyledContainer } from "./Styled";

interface StepActionButtonProps {
    onNext?: () => void;
    onFinish?: () => void;
    isLast: boolean;
    disabled?: boolean;
    loading?: boolean;
}

export const StepActionButtonUi: FC<StepActionButtonProps> = ({
    isLast,
    onNext = () => {},
    onFinish = () => {},
    disabled = false,
    loading = false,
}) => {
    return (
        <StyledContainer>
            <BaseButton
                disabled={disabled}
                type="primary"
                onClick={isLast ? onFinish : onNext}
                loading={loading}
            >
                {isLast ? "Завершити задачу" : "Перейти до наступної підзадачі"}
            </BaseButton>
        </StyledContainer>
    );
};
